import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["startTime", "endTime", "duration", "preview", "slotCount"]

  connect() {
    console.log("Schedule modal form controller connected")
    // Update preview immediately when modal loads with existing values
    this.updatePreview()
  }

  updatePreview() {
    console.log("Updating schedule preview...")
    
    const startTime = this.startTimeTarget.value
    const endTime = this.endTimeTarget.value
    const duration = parseInt(this.durationTarget.value)

    console.log("Schedule values:", { startTime, endTime, duration })

    if (!startTime || !endTime || !duration || isNaN(duration)) {
      this.showEmptyState()
      return
    }

    // Validate time range
    if (startTime >= endTime) {
      this.showErrorState("End time must be after start time")
      return
    }

    // Generate time slots
    const slots = this.generateTimeSlots(startTime, endTime, duration)
    this.renderTimeSlots(slots)
    this.updateSlotCount(slots.length)
  }

  generateTimeSlots(startTime, endTime, duration) {
    const slots = []
    const start = new Date(`2024-01-01 ${startTime}`)
    const end = new Date(`2024-01-01 ${endTime}`)
    
    let current = start
    
    while (current < end) {
      slots.push(new Date(current))
      current = new Date(current.getTime() + duration * 60000) // Add duration in milliseconds
    }
    
    return slots
  }

  renderTimeSlots(slots) {
    const maxSlots = 8 // Limit display to first 8 slots
    const displaySlots = slots.slice(0, maxSlots)
    
    let html = ""
    
    displaySlots.forEach(slot => {
      const timeStr = slot.toLocaleTimeString('en-US', { 
        hour: '2-digit', 
        minute: '2-digit',
        hour12: false
      })
      
      html += `
        <div class="flex items-center text-sm">
          <span class="w-16 text-gray-600 font-mono">${timeStr}</span>
          <div class="flex-1 h-6 bg-white border border-gray-300 rounded flex items-center px-2 ml-2">
            <span class="text-xs text-gray-700">Available</span>
          </div>
        </div>
      `
    })
    
    if (slots.length > maxSlots) {
      html += `
        <div class="text-center">
          <span class="text-xs text-gray-500">+ ${slots.length - maxSlots} more slots...</span>
        </div>
      `
    }
    
    this.previewTarget.innerHTML = html
  }

  updateSlotCount(count) {
    if (this.hasSlotCountTarget) {
      this.slotCountTarget.textContent = `${count} slots available`
    }
  }

  showEmptyState() {
    this.previewTarget.innerHTML = `
      <div class="text-center py-4">
        <span class="text-sm text-gray-500">Set work hours to see schedule preview</span>
      </div>
    `
    this.updateSlotCount(0)
  }

  showErrorState(message) {
    this.previewTarget.innerHTML = `
      <div class="text-center py-4">
        <span class="text-sm text-red-500">${message}</span>
      </div>
    `
    this.updateSlotCount(0)
  }
}